// Navegación suave nativa a una sección (sin librerías de scroll-hijacking).
export const scrollToSection = (target) => {
  if (!target) return;
  const el = document.querySelector(target);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 60;
  window.scrollTo({ top, behavior: "smooth" });
};
